import { mixpanelClient } from "analytics/mixpanel";

export interface QueuedEvent {
  method: string;
  args: any[];
}

export const trackPageView = () => {
  // Page views are also automatically tracked via Google Tag Manager on inital page view and route changes
  // @see: https://tagmanager.google.com/#/container/accounts/6002437092/containers/34296272/workspaces/
  mixpanelClient.trackPageView();
};

export const initAnalytics = async (enableTracking: boolean) => {
  await mixpanelClient.initializeMixpanel(enableTracking);

  if (enableTracking) {
    trackPageView();
  }
};

export const enableAnalyticsTracking = () => {
  mixpanelClient.optInTracking();
  trackPageView();
};
